import React from 'react'

const PentagonMarker = () => (
  <svg viewBox="-4 -12 84 84" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-5, -12) scale(1.2)">
      <polygon
        className="map-marker-shape"
        points="36,4 68,28 55,66 17,66 4,28"
      />
    </g>
  </svg>
)

export default PentagonMarker
